import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { parseSPBlockedResponse } from './parseSPBlockedResponse';
import { renderSPBlockedStub } from './renderSPBlockedStub';
import { SPBlockedError } from './SPBlockedError';

const getContentType = (response: AxiosResponse): string | undefined => {
    const contentType = response.headers?.['content-type'];
    return typeof contentType === 'string' ? contentType : undefined;
};

const shouldSkipSPCheck = (response: AxiosResponse): boolean => {
    const responseType = response.config?.responseType;
    return responseType === 'blob' || responseType === 'arraybuffer';
};

const handleSPBlockedResponse = (response: AxiosResponse): Promise<never> | null => {
    if (shouldSkipSPCheck(response)) {
        return null;
    }

    const spReport = parseSPBlockedResponse(response.data, getContentType(response));

    if (!spReport) {
        return null;
    }

    void renderSPBlockedStub(spReport);
    return Promise.reject(new SPBlockedError(spReport, response));
};

export const spResponseInterceptor = (response: AxiosResponse): AxiosResponse | Promise<never> => {
    const rejection = handleSPBlockedResponse(response);

    if (rejection) {
        return rejection;
    }

    return response;
};

export const spResponseErrorInterceptor = (error: AxiosError): Promise<never> => {
    if (error.response) {
        const rejection = handleSPBlockedResponse(error.response);

        if (rejection) {
            return rejection;
        }
    }

    return Promise.reject(error);
};

let interceptorId: number | null = null;

export const installSPInterceptor = (axiosInstance: AxiosInstance) => {
    if (interceptorId !== null) {
        return;
    }

    interceptorId = axiosInstance.interceptors.response.use(
        spResponseInterceptor,
        spResponseErrorInterceptor,
    );
};
